import React, { useEffect, useRef, createElement } from 'react';
import { SecretWelcomeSection } from '../components/SecretWelcomeSection';
import { BookingSection } from '../components/BookingSection';
export default function SeccionSecretaPage() {
  const testSectionRef = useRef<HTMLDivElement>(null);
  // Load Typeform script on mount
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const scrollToTest = () => {
    testSectionRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#0C0A09] text-[#F5EDE0]" data-id="element-490">
      {/* Welcome Section at the top */}
      <SecretWelcomeSection onStart={scrollToTest} data-id="element-491" />

      {/* Test Section (Paso 01) */}
      <div ref={testSectionRef} className="w-full max-w-[780px] mx-auto py-20 px-4 animate-fadeIn" data-id="element-492">
        <div className="text-center space-y-4 mb-12" data-id="element-493">
          <div className="inline-block px-3 py-1 rounded-full border border-[#C89B40]/30 bg-[#C89B40]/5 text-[#C89B40] text-xs tracking-widest uppercase mb-2" data-id="element-494">
            Paso 01
          </div>
          <h2 className="text-3xl font-serif text-[#F5EDE0]" data-id="element-495">
            Descubre tu Arquetipo
          </h2>
          <p className="text-sm text-[#d9cec0]/70 max-w-md mx-auto" data-id="element-496">
            Completa el formulario a continuación. Tómate tu tiempo y asegúrate
            de estar en un lugar tranquilo.
          </p>
        </div>

        <div className="relative rounded-lg p-1" style={{
        background: 'linear-gradient(135deg, rgba(202, 155, 64, 0.15), rgba(202, 155, 64, 0.05))',
        boxShadow: '0 0 60px rgba(202, 155, 64, 0.1), 0 0 100px rgba(202, 155, 64, 0.05), inset 0 0 40px rgba(202, 155, 64, 0.05)'
      }} data-id="element-497">
          <div className="bg-[#0C0A09] rounded-lg overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-498">
            <div data-tf-live="01KBRJR0PV8AXQC9B09DB4Z2FP" data-id="element-499"></div>
          </div>
        </div>
      </div>

      {/* Booking Section (Paso 03) */}
      <BookingSection data-id="element-500" />

      <style data-id="element-501">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeIn 1s ease-out forwards;
        }
      `}</style>
    </div>;
}